// extracted by mini-css-extract-plugin
export default {"form":"file-input_form__C23AI","label":"file-input_label__fJNfx","pseudoLabel":"file-input_pseudoLabel__pBFp+","input":"file-input_input__ugWE8"};